import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const Portfolio = () => {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUserType = localStorage.getItem("usertype");
    const storedUserName = localStorage.getItem("userName");
    const storedFName = localStorage.getItem("fname");
    const storedLName = localStorage.getItem("lname");
    const storedEmail = localStorage.getItem("email");
    const storedUserId = localStorage.getItem("userId");

    if (!storedUserType) {
      navigate("/login");
    } else {
      setUserType(storedUserType);
      setUserFullName(`${storedFName} ${storedLName}`);
      
      // Create complete user data object
      setUserData({
        id: storedUserId,
        fname: storedFName,
        lname: storedLName,
        username: storedUserName,
        email: storedEmail,
        usertype: storedUserType,
        joinDate: localStorage.getItem("date") || "Not available",
        status: localStorage.getItem("status") || "Active"
      });
      setLoading(false);
    }
  }, [navigate]);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="admin-navbar">
                    <h1 className="welcome-text">Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logout-btn btn btn-warning">
                        Logout
                    </button>
                </div>

        <div className="mainsection p-4">
          <div className="card shadow">
            <div className="card-header text-white">
              <h3 className='section-title text-center'>
                <i className="bi bi-person-circle me-2"></i>
                My Profile
              </h3>
            </div>
            
            {loading ? (
              <div className="card-body text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading profile information...</p>
              </div>
            ) : (
              <div className="card-body">
                <div className="row mb-4">
                  <div className="col-md-4 text-center">
                    <div className="profile-avatar mx-auto mb-3">
                      <i className="bi bi-person-circle" style={{ fontSize: "5rem", color: "#147D9B" }}></i>
                    </div>
                    <h4>{userFullName}</h4>
                    <span className={`badge ${userData.usertype === 'administrator' ? 'bg-danger' : userData.usertype === 'admin' ? 'bg-warning' : 'bg-success'}`}>
                      {userData.usertype}
                    </span>
                  </div>
                  
                  <div className="col-md-8">
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <tbody>
                          <tr>
                            <th className="bg-light" style={{ width: '30%' }}>User ID</th>
                            <td>{userData.id || 'N/A'}</td>
                          </tr>
                          <tr>
                            <th className="bg-light">Full Name</th>
                            <td>{userData.fname} {userData.lname}</td>
                          </tr>
                          <tr>
                            <th className="bg-light">Username</th>
                            <td>{userData.username}</td>
                          </tr>
                          <tr>
                            <th className="bg-light">Email</th>
                            <td>
                              <a href={`mailto:${userData.email}`}>{userData.email}</a>
                            </td>
                          </tr>
                          <tr>
                            <th className="bg-light">Account Type</th>
                            <td>
                              <span className={`text-capitalize ${userData.usertype === 'administrator' ? 'text-danger' : userData.usertype === 'admin' ? 'text-warning' : 'text-success'}`}>
                                {userData.usertype}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <th className="bg-light">Member Since</th>
                            <td>{userData.joinDate}</td>
                          </tr>
                          <tr>
                            <th className="bg-light">Account Status</th>
                            <td>
                              <span className={`badge ${userData.status === 'Active' ? 'bg-success' : 'bg-secondary'}`}>
                                {userData.status}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button className="btn btn-outline-primary me-md-2">
                    <i className="bi bi-pencil-square me-2"></i>Edit Profile
                  </button>
                  <button className="btn btn-primary">
                    <i className="bi bi-shield-lock me-2"></i>Change Password
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;